import { API } from '@/src/api/api'
import { queryKeys } from '@/src/api/queryKeys'
import { useLocationsContext } from '@/src/contexts/LocationsContext'
import type { EnPI } from '@/src/types/enpi.type'
import { useQuery } from '@tanstack/react-query'

export const useEnpis = () => {
  const { companyPgId } = useLocationsContext()

  return useQuery<EnPI[]>({
    queryKey: queryKeys.iso.enpis.manyByCompanyId.toKeyWithArgs(companyPgId),
    queryFn: async () => {
      if (!companyPgId) return []

      const result = await API.enpi.fetch(companyPgId)
      const enpis: EnPI[] = []
      if (result?.enpis && result.enpis.length > 0) {
        for (let i = 0; i < result.enpis.length; i++) {
          const enpi: EnPI = {
            ...result.enpis[i],
            unit: result.enpis[i].influencingFactor?.unit ? `kWh/ ${result.enpis[i].influencingFactor?.unit}` : 'kWh',
            influencingFactorResolution: result.enpis[i].influencingFactor?.resolution?.enum,
          }
          enpis.push(enpi)
        }
      }
      return enpis
    },
    enabled: !!companyPgId,
  })
}
